import { render } from "./EditorView.vue?vue&type=template&id=22cc1a4c&scoped=true"
import script from "./EditorView.vue?vue&type=script&lang=js"
export * from "./EditorView.vue?vue&type=script&lang=js"

import "./EditorView.vue?vue&type=style&index=0&id=22cc1a4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cc1a4c"]])

export default __exports__